import React from 'react';
import {
    Button,
    Card,
    CardContent,
    CardHeader,
    Divider,
    makeStyles,
} from '@material-ui/core';
import { Mail as MailIcon } from 'react-feather';
import { IModalButton } from './types';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(() => ({
    root: {},
    button: { height: 60 },
}));

export const ModalButton = ({ setOpen, lead, ...rest }: IModalButton) => {
    const classes = useStyles();
    const { t } = useTranslation();

    const handleOpen = () => setOpen(true);

    return (
        <Card className={classes.root} {...rest}>
            <CardHeader title={t('Buttons.Documentation')} />
            <Divider />
            <CardContent>
                <Button
                    className={classes.button}
                    variant="contained"
                    type="submit"
                    size="large"
                    fullWidth
                    color="primary"
                    startIcon={<MailIcon />}
                    onClick={handleOpen}
                    disabled={!lead?.agent}
                >
                    {t('Buttons.SendEmail')}
                </Button>
            </CardContent>
        </Card>
    );
};
